export default __webpack_public_path__ + "static/media/bar_graph.6f02ecbb.svg";